/* ollihess – Sound-Player pro Variante (custom, nicht Teil des Basis-Themes)
 * Ein Player, dessen Dropdown die Varianten listet. Auswahl spielt deren Sound UND
 * schaltet die Produktvariante um (Zwei-Wege-Sync mit Impacts <variant-picker>).
 * Gegenrichtung: lauscht auf 'variant:change' und zieht mit. Echo-Schutz via _syncing.
 * Treibt zwei Markups: die Sektion sound-player (mit Volume/Mute) und die in die
 * Varianten-Story integrierte Karte (ohne Volume, mit [data-wave]-Waveform).
 * Volume-, Mute- und Info-Elemente sind daher optional.
 */
(function () {
  if (window.customElements && customElements.get('sound-player')) return;

  function fmt(t) {
    if (!isFinite(t) || t < 0) t = 0;
    var m = Math.floor(t / 60), s = Math.floor(t % 60);
    return m + ':' + (s < 10 ? '0' : '') + s;
  }
  function cssEsc(s) {
    if (window.CSS && CSS.escape) return CSS.escape(s);
    return String(s).replace(/["\\]/g, '\\$&');
  }

  class SoundPlayer extends HTMLElement {
    connectedCallback() {
      if (this._init) return;
      this._init = true;
      this._syncing = false;

      this.audio = this.querySelector('[data-audio]');
      this.select = this.querySelector('[data-variant-select]');
      this.player = this.querySelector('[data-player]');
      this.playBtn = this.querySelector('[data-play]');
      this.iconPlay = this.querySelector('[data-icon-play]');
      this.iconPause = this.querySelector('[data-icon-pause]');
      this.prevBtn = this.querySelector('[data-prev]');
      this.nextBtn = this.querySelector('[data-next]');
      this.scrubber = this.querySelector('[data-scrubber]');
      this.curEl = this.querySelector('[data-current]');
      this.durEl = this.querySelector('[data-duration]');
      this.muteBtn = this.querySelector('[data-mute]');
      this.iconVol = this.querySelector('[data-icon-vol]');
      this.iconMuted = this.querySelector('[data-icon-muted]');
      this.volume = this.querySelector('[data-volume]');
      this.infoBtn = this.querySelector('[data-info-btn]');
      this.wave = this.querySelector('[data-wave]');

      if (!this.audio || !this.select) return;

      this.handle = this.getAttribute('data-handle') || '';
      this.ids = (this.getAttribute('data-variant-ids') || '').split(',')
        .map(function (s) { return s.trim(); }).filter(Boolean);

      this._bind();
      this._updateVol();
      this._activate(this.select.value, { syncPicker: false, autoplay: false });

      this._onVariantChange = this._onVariantChange.bind(this);
      document.addEventListener('variant:change', this._onVariantChange, true);
    }

    disconnectedCallback() {
      this._stopRAF();
      if (this._onVariantChange) document.removeEventListener('variant:change', this._onVariantChange, true);
    }

    _bind() {
      var self = this;
      this.select.addEventListener('change', function () {
        self._activate(self.select.value, { syncPicker: true, autoplay: false });
      });
      this.playBtn.addEventListener('click', function () { self._toggle(); });
      if (this.prevBtn) this.prevBtn.addEventListener('click', function () { self._step(-1); });
      if (this.nextBtn) this.nextBtn.addEventListener('click', function () { self._step(1); });
      if (this.muteBtn) {
        this.muteBtn.addEventListener('click', function () {
          self.audio.muted = !self.audio.muted;
          self._updateVol();
        });
      }
      if (this.volume) {
        this.volume.addEventListener('input', function () {
          self.audio.volume = parseFloat(self.volume.value);
          self.audio.muted = self.audio.volume === 0;
          self._updateVol();
        });
      }
      this.scrubber.addEventListener('input', function () {
        if (self.audio.duration) {
          self.audio.currentTime = (parseFloat(self.scrubber.value) / 100) * self.audio.duration;
        }
        self._tick();
      });
      // Nur als Fallback ticken, wenn keine rAF-Schleife laeuft (z.B. pausiert / Tab inaktiv).
      this.audio.addEventListener('timeupdate', function () { if (!self._raf) self._tick(); });
      this.audio.addEventListener('loadedmetadata', function () {
        self.durEl.textContent = fmt(self.audio.duration);
        self._tick();
      });
      this.audio.addEventListener('ended', function () {
        self._stopRAF();
        self._setPlaying(false);
        self.scrubber.value = 0;
        self._setProgress('0%');
      });
      this.audio.addEventListener('play', function () { self._setPlaying(true); self._startRAF(); });
      this.audio.addEventListener('pause', function () { self._setPlaying(false); self._stopRAF(); });
    }

    _startRAF() {
      if (this._raf) return;
      var self = this;
      var loop = function () {
        self._tick();
        self._raf = requestAnimationFrame(loop);
      };
      this._raf = requestAnimationFrame(loop);
    }

    _stopRAF() {
      if (this._raf) { cancelAnimationFrame(this._raf); this._raf = null; }
    }

    get _opt() { return this.select.options[this.select.selectedIndex]; }

    _activate(variantId, opts) {
      opts = opts || {};
      if (this.select.value !== String(variantId)) this.select.value = String(variantId);
      var opt = this._opt;
      if (!opt) return;

      var src = opt.getAttribute('data-src') || '';
      var info = opt.getAttribute('data-info') || '';

      this.audio.pause();
      if (src) {
        if (this.audio.getAttribute('src') !== src) {
          this.audio.setAttribute('src', src);
          this.audio.load();
        }
        this.player.hidden = false;
      } else {
        this.audio.removeAttribute('src');
        this.player.hidden = true;
      }
      // Variante ohne Sound: die ganze Karte verschwindet statt eines Hinweistexts.
      this.toggleAttribute('hidden', !src);

      if (this.infoBtn) {
        if (info) {
          this.infoBtn.hidden = false;
          this.infoBtn.setAttribute('data-tooltip', info);
          this.infoBtn.setAttribute('aria-label', info);
        } else {
          this.infoBtn.hidden = true;
          this.infoBtn.removeAttribute('data-tooltip');
          this.infoBtn.setAttribute('aria-label', 'Info');
        }
      }

      this.scrubber.value = 0;
      this._setProgress('0%');
      this.curEl.textContent = '0:00';
      this.durEl.textContent = '0:00';
      this._setPlaying(false);
      this._updatePrevNext();

      if (opts.autoplay && src) {
        var p = this.audio.play();
        if (p && p.catch) p.catch(function () {});
      }
      if (opts.syncPicker) this._syncPicker(opt);
    }

    _syncPicker(opt) {
      var picker = this._picker();
      if (!picker) return;
      var values = [opt.getAttribute('data-option1'), opt.getAttribute('data-option2'), opt.getAttribute('data-option3')];
      var self = this;
      this._syncing = true;
      var selectors = picker.querySelectorAll('[data-option-selector]');
      Array.prototype.forEach.call(selectors, function (sel, i) {
        var val = values[i];
        if (val == null || val === '') return;
        var btn = sel.querySelector('[data-option-value][value="' + cssEsc(val) + '"]');
        if (btn) { if (btn.getAttribute('aria-selected') !== 'true') btn.click(); return; }
        var input = sel.querySelector('input[value="' + cssEsc(val) + '"]');
        if (input && !input.checked) { input.checked = true; input.dispatchEvent(new Event('change', { bubbles: true })); }
      });
      setTimeout(function () { self._syncing = false; }, 0);
    }

    _picker() {
      if (this.handle) {
        var p = document.querySelector('variant-picker[handle="' + cssEsc(this.handle) + '"]');
        if (p) return p;
      }
      return document.querySelector('variant-picker');
    }

    _onVariantChange(e) {
      if (this._syncing) return;
      var v = e.detail && e.detail.variant;
      if (!v) return;
      var id = String(v.id);
      if (this.ids.indexOf(id) === -1) return;
      this._activate(id, { syncPicker: false, autoplay: !this.audio.paused });
    }

    _toggle() {
      if (!this.audio.getAttribute('src')) return;
      if (this.audio.paused) {
        var p = this.audio.play();
        if (p && p.catch) p.catch(function () {});
      } else {
        this.audio.pause();
      }
    }

    _step(dir) {
      var n = this.select.options.length;
      if (n < 2) return;
      var i = (this.select.selectedIndex + dir + n) % n;
      this.select.selectedIndex = i;
      this._activate(this.select.value, { syncPicker: true, autoplay: !this.audio.paused });
    }

    _tick() {
      var d = this.audio.duration, c = this.audio.currentTime;
      this.curEl.textContent = fmt(c);
      if (isFinite(d) && d > 0) {
        var pct = (c / d) * 100;
        this.scrubber.value = pct;
        this._setProgress(pct + '%');
      }
    }

    _setProgress(val) {
      this.scrubber.style.setProperty('--oh-progress', val);
      if (this.wave) this.wave.style.setProperty('--oh-progress', val);
    }

    _setPlaying(on) {
      // SVG-Elemente haben keine funktionierende .hidden-Property (kein HTMLElement),
      // daher Attribut explizit toggeln, damit [hidden] im CSS greift.
      if (this.iconPlay) this.iconPlay.toggleAttribute('hidden', on);
      if (this.iconPause) this.iconPause.toggleAttribute('hidden', !on);
      this.playBtn.setAttribute('aria-label', on ? 'Pause' : 'Abspielen');
      // Fuer CSS ausserhalb des Players, z.B. die pulsierenden Gong-Ringe in klang-anwendung.
      this.classList.toggle('is-playing', on);
    }

    _updateVol() {
      if (!this.volume) return;
      var muted = this.audio.muted || this.audio.volume === 0;
      if (this.iconVol) this.iconVol.toggleAttribute('hidden', muted);
      if (this.iconMuted) this.iconMuted.toggleAttribute('hidden', !muted);
      var v = this.audio.muted ? 0 : this.audio.volume;
      this.volume.value = v;
      this.volume.style.setProperty('--oh-progress', (v * 100) + '%');
    }

    _updatePrevNext() {
      var n = this.select.options.length;
      if (this.prevBtn) this.prevBtn.disabled = n <= 1;
      if (this.nextBtn) this.nextBtn.disabled = n <= 1;
    }
  }

  customElements.define('sound-player', SoundPlayer);
})();
